module.exports = __webpack_public_path__ + "img/services-sur-mesure.2e0234a.jpeg";